import { store } from '@core/Store'
import { setSecureSkyUrl } from '../Store'
import { logError } from '@core/Utils'
import {
  getSkyVisionSecureUrl,
  type SkyVideoEntitlementDto,
} from '@core/Areas/SkyVideoPlayer/Components/VideoPlayer/api'

/**
 * Checks if we have a valid cached secure URL
 */
function hasValidCachedUrl(channel: 'Sky1' | 'Sky2'): boolean {
  const state = store.getState()
  const existingUrl =
    channel === 'Sky1' ? state.skyVideoPlayer.sky1SecureUrl : state.skyVideoPlayer.sky2SecureUrl
  const expiry = state.skyVideoPlayer.secureUrlExpiry

  return !!(existingUrl && expiry && Date.now() < expiry)
}

/**
 * Fetches secure URL from backend API
 */
async function fetchSecureUrlFromApi(baseUrl: string): Promise<SkyVideoEntitlementDto> {
  return getSkyVisionSecureUrl(baseUrl)
}

export async function fetchAndStoreSkySecureUrl(channel: 'Sky1' | 'Sky2'): Promise<void> {
  try {
    const baseUrl =
      channel === 'Sky1'
        ? 'https://skyliverwwatk.akamaized.net/cmaf/live/2030963/sky1/index.m3u8'
        : 'https://skyliverwwatk.akamaized.net/cmaf/live/2030964/sky2/index.m3u8'

    if (hasValidCachedUrl(channel)) {
      return
    }

    const result = await fetchSecureUrlFromApi(baseUrl)

    if (result.IsEntitled && result.SecureUri) {
      store.dispatch(
        setSecureSkyUrl({
          channel,
          secureUrl: result.SecureUri,
        })
      )
    } else {
      logError(
        `getSkyVisionSecureUrl: Not entitled or failed for channel=${channel}, baseUrl=${baseUrl}`
      )
    }
  } catch {
    logError(`fetchAndStoreSkySecureUrl: Failed to retrieve secure URL for channel=${channel}`)
  }
}
